import React, { useState } from 'react';
import MainLayout from '../components/MainLayout';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, ListChecks, UsersRound } from 'lucide-react';
import { MyRequestsList } from '../components/MyRequestsList';
import { ManagerApprovalInbox } from '../components/ManagerApprovalInbox';
import { EmployeeWorkspaceOverview } from '../components/EmployeeDashboardView';

const ESSPortal = () => {
  const { user, isReportingManager } = useAuth();
  const [tab, setTab] = useState('overview'); // overview | my_requests | team_approvals

  return (
    <MainLayout>
      <div data-testid="ess-portal-page" className="space-y-6 max-w-7xl">
        {/* Navigation Tabs */}
        <div className="flex flex-wrap items-center justify-between gap-4 border-b border-slate-200 pb-4" data-testid="ess-portal-tabs">
          <div className="flex flex-wrap gap-2">
            {[
              { key: 'overview', label: 'My Overview Workspace', icon: LayoutDashboard },
              { key: 'my_requests', label: 'My Requests & Inbox', icon: ListChecks },
              ...(isReportingManager ? [{ key: 'team_approvals', label: 'My Team Approvals', icon: UsersRound }] : []),
            ].map((t) => (
              <button
                key={t.key}
                data-testid={`ess-tab-${t.key}`}
                onClick={() => setTab(t.key)}
                className={`inline-flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-bold transition-all shadow-xs ${
                  tab === t.key
                    ? 'bg-[#0052FF] text-white shadow-sm'
                    : 'bg-white text-slate-600 border border-slate-200 hover:border-slate-300 hover:bg-slate-50'
                }`}
              >
                <t.icon className="w-4 h-4" /> {t.label}
              </button>
            ))}
          </div>
        </div>

        {tab === 'my_requests' && (
          <div data-testid="ess-my-requests-tab" className="bg-white rounded-2xl border border-slate-200 p-6 shadow-xs">
            <h2 className="text-base font-bold text-slate-800 mb-4">My Requests & Submitted Items</h2>
            <MyRequestsList />
          </div>
        )}

        {tab === 'team_approvals' && isReportingManager && (
          <div data-testid="ess-team-approvals-tab" className="bg-white rounded-2xl border border-slate-200 p-6 shadow-xs">
            <h2 className="text-base font-bold text-slate-800 mb-4">My Team Approvals — Pending Action</h2>
            <ManagerApprovalInbox embedded />
          </div>
        )}

        {tab === 'overview' && <EmployeeWorkspaceOverview user={user} />}
      </div>
    </MainLayout>
  );
};

export default ESSPortal;
